<template>
  <section ref="userInfoRef" class="w-full">
    <open-app-btn :extinfo="extinfo">
      <component :is="'style'">
        .user-info-box { display:flex; align-items: stretch; justify-content:
        space-between; width: {{ userInfoWidth }}; padding: {{ rootRem / 2 }}px 0; }
        .user-info-left { display:flex; height: 100%; align-items: stretch; gap:
        {{ rootRem / 2 }}px; } .user-info-avatar { height: {{ rootRem * 3 }}px; width:
        {{ rootRem * 3 }}px; border-radius: 9999px; } .user-info-msg { display:flex;
        flex-direction: column; justify-content: space-between; } .user-info-nickname {
        font-weight: 600; color: #333; } .user-info-time { color: #888; font-size: 14px; }
        .user-info-subscribe { display:flex; align-items: center; }
        .user-info-subscribe-btn { height: {{ rootRem * 1.5 }}px; width:
        {{ rootRem * 4 }}px; display: flex; align-items: center; justify-content: center;
        font-size: {{ rootRem * 0.875 }}px;border-radius: 9999px; } .dynamic-subscribe {
        background-image: linear-gradient(to right, #EF4243, #FA7419); color: white; }
        .subject-subscribe { color: #f68e8f; border: 1px solid #f68e8f; }
      </component>
      <div class="user-info-box">
        <div class="user-info-left">
          <img
            class="user-info-avatar"
            :src="user.head || defaultAvatar"
            :onerror="'this.src=' + defaultAvatar"
            :alt="user.nickName"
          />
          <div class="user-info-msg">
            <div class="user-info-nickname">
              {{ user.nickName }}
            </div>
            <div class="user-info-time">
              {{ getLatesMinutes(publishTime || '') }}
            </div>
          </div>
        </div>
        <div class="user-info-subscribe">
          <div
            class="user-info-subscribe-btn"
            :class="{ 'dynamic-subscribe': !isSubject, 'subject-subscribe': isSubject }"
          >
            关注
          </div>
        </div>
      </div>
    </open-app-btn>
  </section>
</template>

<script setup lang="ts">
import { getLatesMinutes } from '@/utils';
import { useRem } from '@/utils/hooks.ts';

const defaultAvatar = import.meta.env.VITE_DEFAULT_AVATAR;

withDefaults(
  defineProps<{
    extinfo: string;
    user: Dynamic.DynamicUser;
    publishTime: number;
    isSubject?: boolean;
  }>(),
  {
    isSubject: false,
  },
);

const userInfoRef = ref();
const { width } = useElementSize(userInfoRef);
const userInfoWidth = computed(() => {
  return width.value > 0 ? `${width.value}px` : '100%';
});

const rootRem = useRem();
</script>
